"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { CircleQuestionMark as CircleHelp, Mail } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function Terms() {
  const shouldReduceMotion = useReducedMotion();
  const fadeIn = {
    initial: shouldReduceMotion ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 16
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true,
      amount: 0.15
    },
    transition: {
      duration: 0.4,
      ease: [0.16, 1, 0.3, 1]
    }
  };
  return <section id="terms-and-conditions" data-nav="light" className="bg-background text-foreground py-14 md:py-20 lg:py-24 border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Top Dividing Line Indicator */}
        <div className="mb-8">
          <Separator className="bg-border" />
        </div>

        {/* Header Block */}
        <motion.div {...fadeIn} className="max-w-3xl mb-12 md:mb-16 space-y-4">
          <div className="flex flex-wrap items-center gap-2">
            <Badge variant="outline" className="bg-accent text-accent-foreground border-accent-foreground/20 font-mono tracking-wide text-xs px-3 py-1.5 rounded-lg uppercase whitespace-normal max-w-full text-left leading-relaxed">
              <span className="size-2 rounded-full bg-chart-1 mr-1.5 inline-block shrink-0 animate-pulse" />
              DRAFT TERMS — PENDING FINAL CLIENT REVIEW (NOT FINAL LEGAL CONTENT)
            </Badge>
          </div>

          <h2 className="font-sans text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-foreground">
            Terms and conditions
          </h2>

          <p className="text-muted-foreground text-base sm:text-lg leading-relaxed">
            This page is pending owner and legal review. Final website and rental terms will be added before launch. Rental terms are provided separately and are not created by this website.
          </p>
        </motion.div>

        {/* Contact & Support Strip */}
        <motion.div {...fadeIn} className="mt-12 md:mt-16 rounded-lg border border-border bg-muted/50 p-6 sm:p-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="space-y-2 max-w-xl">
            <div className="flex items-center gap-2">
              <CircleHelp className="size-5 text-primary shrink-0" />
              <h3 className="font-sans text-lg font-semibold text-foreground">
                Questions about our rental terms?
              </h3>
            </div>
            <p className="text-sm text-muted-foreground">
              Contact our dispatch team for clarification regarding cold storage trailer rental agreements, electrical setups, or regional delivery.
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-3 w-full sm:w-auto">
            <Button asChild variant="default" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md px-5 py-2.5 text-sm font-medium">
              <Link to="/ContactRequestAQuotePage">
                Request a Quote
              </Link>
            </Button>

            <a href="mailto:Info@Fridgefleet.com" className="inline-flex items-center gap-2 border border-border bg-card text-muted-foreground rounded-md px-3.5 py-2 text-xs sm:text-sm font-mono max-w-full break-all">
              <Mail className="size-4 shrink-0 text-muted-foreground" />
              <span>Info@Fridgefleet.com</span>
            </a>

            <a href="tel:2135218821" className="inline-flex items-center gap-2 border border-border bg-card text-muted-foreground rounded-md px-3.5 py-2 text-xs sm:text-sm font-mono">
              <span>213-521-8821</span>
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}